import { AdminConsoleAccessGuard, AdminPageContainer, AdminSectionCard } from "../../components/admin-console/admin-console-shell";
import { PageStoreProvider } from "./constructor-roads-page.lib";
import { ConstructorRoadsTabs } from "./local-components/constructor-roads-tabs";
import { ConstructorRoadsTable } from "./local-components/constructor-roads-table";
import { ConstructorRoadsToolbar } from "./local-components/constructor-roads-toolbar";
import { RoadFormModal } from "./local-components/road-form-modal";

/** ЛК администратора услуг — «Конструктор — Дороги». */
const ConstructorRoadsPage = () => (
  <AdminConsoleAccessGuard>
    <PageStoreProvider>
      <RoadFormModal />
      <AdminPageContainer>
        <AdminSectionCard
          title="Конструктор"
          subtitle="Настройка услуг портала, их бизнес-процессов по дорогам и комплектов документов для заявителей"
        >
          <ConstructorRoadsTabs />
          <ConstructorRoadsToolbar />
          <ConstructorRoadsTable />
        </AdminSectionCard>
      </AdminPageContainer>
    </PageStoreProvider>
  </AdminConsoleAccessGuard>
);

export default ConstructorRoadsPage;
